export const PanelConstants = {
  loginPage: '/login',
  newPrqPage: '/publiccreatepickup',
  ssoClientId: 'express_app',
  defaultRoute: '/bulktrackconsignment',
  eretl: 'ERETL'
};
